import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import boardReducer from '@chronos/slices/boardSlice';
import estimatesApi from '@chronos/slices/estimatesApi';
import cardReducer from '@chronos/slices/cardSlice';
import usersApi from '@chronos/slices/usersApi';
import boardsApi from '@chronos/slices/boardsApi';

export default (reducers) => {
  const store = configureStore({
    reducer: {
      ...reducers,
      shared: combineReducers({
        board: boardReducer,
        card: cardReducer,
      }),
      [estimatesApi.reducerPath]: estimatesApi.reducer,
      [usersApi.reducerPath]: usersApi.reducer,
      [boardsApi.reducerPath]: boardsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        estimatesApi.middleware,
        usersApi.middleware
      ),
    devTools: false,
  });

  setupListeners(store.dispatch);
  return store;
};
